import { Component } from '@angular/core';

@Component({
	selector: 'sm-p500',
	template: require('./p500.component.html')
})
export class SmP500Component { }


// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./app/shared/components/p500.component.ts